var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileSectionPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 335,
  height: 1353,
  viewBox: "0 0 335 1353",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5246_146031)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 335,
  y1: 0.500977,
  x2: -4.37114e-8,
  y2: 0.500947,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 16.001,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 59.001,
  width: 335,
  height: 223,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 294.001,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 324.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 411.001,
  width: 335,
  height: 60,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 483.001,
  width: 150,
  height: 16,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 519.501,
  x2: -4.37114e-8,
  y2: 519.501,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 539.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 626.001,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 660.501,
  x2: -4.37114e-8,
  y2: 660.501,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 680.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 767.001,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 801.501,
  x2: -4.37114e-8,
  y2: 801.501,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 821.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 908.001,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 942.501,
  x2: -4.37114e-8,
  y2: 942.501,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 962.001,
  width: 335,
  height: 75,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1049,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.1,
  x1: 335,
  y1: 1083.5,
  x2: -4.37114e-8,
  y2: 1083.5,
  stroke: "black"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1103,
  width: 157.5,
  height: 128,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1243,
  width: 157.5,
  height: 84,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 1339,
  width: 157.5,
  height: 14,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 177.5,
  y: 1103,
  width: 157.5,
  height: 128,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 177.5,
  y: 1243,
  width: 157.5,
  height: 84,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 177.5,
  y: 1339,
  width: 157.5,
  height: 14,
  fill: "#E5E5E5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5246_146031"
}, /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 1353,
  fill: "white",
  transform: "translate(0 0.000976562)"
})))));
export default SvgMobileSectionPlaceholder;